import {DropdownPosition} from '>shared/components/menu/dropdown';
import {ScreenSize, getCurrentScreenSize} from '>shared/styles/breakpoints';

export function calculateDropdownPosition() {
  const tabletScreenSizes = [ScreenSize.Medium, ScreenSize.Small, ScreenSize.XSmall];
  const isCurrentScreenMobile = tabletScreenSizes.includes(getCurrentScreenSize());

  return isCurrentScreenMobile ? DropdownPosition.AlignBottomRight : DropdownPosition.TopRight;
}
